import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { personas } from './personas';
import './style.css';
import './animate.css';

import Brian_full from './images/Brian_full.jpg';
import Brian_square from './images/Brian_square.jpg';
import Francis_full from './images/Francis_full.jpg';
import Francis_square from './images/Francis_square.jpg';
import Fred_full from './images/Fred_full.jpg';
import Fred_square from './images/Fred_square.jpg';

const imageMap = {
  'images/Brian_full.jpg': Brian_full,
  'images/Brian_square.jpg': Brian_square,
  'images/Francis_full.jpg': Francis_full,
  'images/Francis_square.jpg': Francis_square,
  'images/Fred_full.jpg': Fred_full,
  'images/Fred_square.jpg': Fred_square,
};

const PersonasPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [activePersona, setActivePersona] = useState(null);

  const openPersona = (persona) => {
	navigate(`/personas/${persona.slug}`);
  };

  const closePersona = () => {
	navigate('/personas');
  };

  useEffect(() => {
	setActivePersona(slug ? personas.find((p) => p.slug === slug) || null : null);
  }, [slug]);

  useEffect(() => {
	const handleEsc = (e) => {
	  if (e.key === 'Escape') navigate('/personas');
	};
	document.addEventListener('keyup', handleEsc);
	return () => document.removeEventListener('keyup', handleEsc);
  }, [navigate]);

  return (
	<div className="personas-container">
	  <div className="grid">
		{personas.map((p) => (
		  <div
			key={p.id}
			className={`grid-item grid-item-${p.id}`}
			onClick={() => openPersona(p)}
		  >
			<img src={imageMap[p.imageFull]} alt={p.name} />
			<div className="grid-item-overlay" />
			<div className="grid-item-text">
			  <h2>{p.name}</h2>
			  <p>{p.summary}</p>
			  <button onClick={() => openPersona(p)}>Read story</button>
			</div>
		  </div>
		))}
	  </div>

	  {activePersona && (
		<div className={`persona-page persona-${activePersona.id}`}>
		  <div className="persona-photo animated slideInLeft" onClick={closePersona}>
			<img src={imageMap[activePersona.imageSquare]} alt={activePersona.name} />
			<div className="persona-photo-overlay" />
		  </div>
		  <div className="persona-story animated slideInRight">
			<h2>{activePersona.name}</h2>
			<h3>{activePersona.storyTitle}</h3>
			<div className="persona-meta">
			  {activePersona.tags.map((tag, i) => (
				<span key={i}>{tag}</span>
			  ))}
			</div>
			<div
			  className="persona-content"
			  dangerouslySetInnerHTML={{ __html: activePersona.content }}
			/>
			<div className="backtogrid"><button onClick={closePersona}>&larr; Back to Personas</button></div>
		  </div>
		  <span className="close" onClick={closePersona}>&times;</span>
		</div>
	  )}
	</div>
  );
};

export default PersonasPage;